import Text from 'components/corporatiu/Text';
import Imatge from 'components/corporatiu/Imatge';
import Icona from 'components/corporatiu/Icona/';
import Boto from 'components/corporatiu/Boto';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatEsdeveniment.module.scss';

const BotoEntrada = (props) => {
    const { disponible, soldOut, gratuit, url, experienciaExclusiva, botoProps } = props;
    const isLinkExtern = url?.startsWith('http://') || url?.startsWith('https://');
    const stylesBoto = clsx({
        [styles.boto]: true,
        [styles.ambIcona]: true,
        [styles.disabled]: !disponible && !experienciaExclusiva
    });

    const _getText = () => {
        if (botoProps?.text) {
            return botoProps?.text;
        } else if (gratuit) {
            return 'Més informació';
        } else {
            return "Compra l'entrada";
        }
    };

    const _getIcona = () => {
        if (botoProps?.enllacExtern) {
            return 'ic_linkexterior';
        } else if (gratuit) {
            return null;
        } else {
            return 'ic_linkexterior';
        }
    };

    return (
        <div className={styles.contentBoto}>
            {soldOut ? (
                <span className={styles.exhaurides}>Entrades exhaurides</span>
            ) : (
                <Boto
                    tag={disponible || experienciaExclusiva ? 'a' : 'button'}
                    novaFinestra={isLinkExtern}
                    className={stylesBoto}
                    link={url}
                    estil='ple3cat100'
                    text={_getText()}
                    icona={_getIcona()}
                    isIconaBlanc={true}
                    iconaInline={true}
                />
            )}
        </div>
    );
};

const Etiquetes = (props) => {
    const { id, etiquetes } = props;
    if (__isEmpty(etiquetes)) return <></>;
    return (
        <div className={styles.etiquetes}>
            {etiquetes.map((etiqueta) => {
                return (
                    <div key={`etiqueta-destacat-esdeveniment-${id}-${etiqueta.id}`} className={styles.etiqueta}>
                        <span data-testid='etiqueta-text'>{etiqueta.desc?.replace('&euro', '€')}</span>
                    </div>
                );
            })}
        </div>
    );
};

const DestacatEsdeveniment = (props) => {
    const { item, className, testId, estil, tipusImatge = 'web_destacat', boto } = props;
    const { id, titol, entradeta, avantitol, imatges, infoExtra, url, inclouEntradaPlaca, etiquetes } = item || props;
    const stylesDestacat = clsx({
        [styles.destacatEsdeveniment]: true,
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    if (!titol) {
        return <></>;
    }

    return (
        <div key={`destacat-esdeveniment-${id}`} className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            <div className={styles.imatgeWrapper}>
                <Etiquetes id={id} etiquetes={etiquetes} />
                {/*{inclouEntradaPlaca && <span className={styles.inclouEntrada}>{inclouEntradaPlaca.desc}</span>}*/}
                <Imatge
                    imatges={imatges}
                    className={styles.imatge}
                    tipus={tipusImatge}
                    numColumnsRow='12'
                    aria-hidden='true'
                    layout='fill'
                    priority={false}
                    data_testid='destacat-img'
                />
            </div>
            <div className={styles.contentWrapper}>
                <div className={styles.avantitolWrapper}>
                    <Icona
                        className={styles.iconaCalendari}
                        icona='calendari'
                        inline={true}
                        alt='Calendari'
                        ariaHidden={true}
                        isBlanc={true}
                    />
                    <div className={styles.avantitol}>{avantitol}</div>
                </div>

                <Text tag='div' className={styles.titol} text={titol} />

                {entradeta && <Text className={styles.entradeta} tag='p' text={entradeta} />}
                {infoExtra && (
                    <div className={styles.infoExtraWrapper}>
                        <Text className={styles.infoExtra} tag='span' text={infoExtra} />
                    </div>
                )}
                <BotoEntrada
                    disponible={!!item?.disponible}
                    soldOut={!!item?.soldOut}
                    gratuit={!!item?.gratuit}
                    experienciaExclusiva={!!item?.experienciaExclusiva}
                    botoProps={boto}
                    url={url}
                />
            </div>
        </div>
    );
};

export default DestacatEsdeveniment;
